import { motion } from 'framer-motion';
import DesignCard from './DesignCard';
import { staggerChildren } from '../../../utils/animations';

/**
 * Design Grid — designs only.
 *
 * Folders render in the FolderSection above the grid (independent of design
 * pagination), so this component only deals with designs.
 */
export default function DesignGrid({
  designs,
  onRetryStation,
  mode,
  playlistCounts,
  onAdd,
  addDisabledReason,
  className = 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6',
}) {
  return (
    <motion.div
      variants={staggerChildren}
      initial="initial"
      animate="animate"
      className={className}
    >
      {designs.map((design) => (
        <motion.div
          key={design.design_id || design.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
          <DesignCard
            design={design}
            onRetryStation={onRetryStation}
            mode={mode}
            playlistCount={playlistCounts?.get(design.design_id || design.id) ?? 0}
            onAdd={onAdd}
            addDisabledReason={addDisabledReason}
          />
        </motion.div>
      ))}
    </motion.div>
  );
}
